import { DateTime } from 'luxon';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HistoricCall from '../components/HistoricCall';
import { fetchCallHistory } from '../reducers/callHistory';
import styles from '../styles/callHistoryList.scss';
import ListSeparator from './ListSeparator';
import Spinner from './Spinner';
const CallHistoryList = () => {
    const dispatch = useDispatch();
    const calls = useSelector((state) => state.callHistory.calls);
    const isFetching = useSelector((state) => state.callHistory.isFetching);
    const [pinnedElementId, setPinnedElementId] = useState(0);
    const callListRef = useRef(null);
    const dateSeparatorsRef = useRef([]);
    const registerSeparator = (id, offsetTop) => {
        dateSeparatorsRef.current.push({
            id,
            offsetTop,
        });
    };
    useEffect(() => {
        const handleScroll = (e) => {
            // Firefox doesn't support .srcElement, it uses .target
            const el = (e.srcElement || e.target);
            const scrollPosition = el === null || el === void 0 ? void 0 : el.scrollTop;
            const dateSeparators = dateSeparatorsRef.current;
            let pinIdx = dateSeparators.findIndex((x) => {
                return scrollPosition < x.offsetTop;
            });
            // If pinIdx is -1 it means we're at the last element, so
            // set pinIdx appropriately
            pinIdx = pinIdx === -1 ? dateSeparators.length : pinIdx;
            const pinnedElement = dateSeparators[pinIdx - 1];
            if (!pinnedElement) {
                return;
            }
            const pinnedElementId = pinnedElement.id;
            setPinnedElementId(pinnedElementId);
            const totalHeight = el.scrollHeight;
            const visibleHeight = el.offsetHeight;
            const visibleBottom = scrollPosition + visibleHeight;
            const approachingEnd = totalHeight - visibleBottom <= 300;
            if (approachingEnd) {
                dispatch(fetchCallHistory({ overrideParams: {} }));
            }
        };
        const currentRef = callListRef.current;
        currentRef === null || currentRef === void 0 ? void 0 : currentRef.addEventListener('scroll', handleScroll);
        return () => currentRef === null || currentRef === void 0 ? void 0 : currentRef.removeEventListener('scroll', handleScroll);
    }, []);
    let day;
    return (React.createElement("ul", { className: styles.list, ref: callListRef },
        calls
            ? calls.map((call, i) => {
                const callMoment = DateTime.fromISO(call.callStarted);
                const callDay = callMoment.ordinal;
                let date;
                if (!day || callDay !== day) {
                    day = callDay;
                    date = callMoment.toFormat('dd MMMM yyyy');
                }
                return (React.createElement("div", { key: call.id },
                    date ? (React.createElement(ListSeparator, { id: i, pinnedElementId: pinnedElementId, title: date, renderCallback: registerSeparator })) : (''),
                    React.createElement(HistoricCall, { call: call })));
            })
            : '',
        isFetching ? (React.createElement("div", { className: styles.spinner_container },
            calls.length ? React.createElement("div", { className: styles.spinner_line }) : '',
            React.createElement(Spinner, { text: 'Loading' }))) : ('')));
};
export default React.memo(CallHistoryList /*, (prevProps, nextProps) => {
const change = Object.keys(prevProps).some((key) => {
  const current = prevProps[key as keyof Props];
  const next = nextProps[key as keyof Props];
  if (Array.isArray(current) && Array.isArray(next)) {
    // We can't directly compare array, so compare length instead
    return next.length !== current.length;
  } else {
    return next !== current;
  }
});

// If there's been a change, render
// If not, don't
return change;
}*/);
